import { ActionLink, Button, Input } from "@nodus/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import * as React from "react";
import { AuthCard } from "../../../app/auth-card";
import { lastScope } from "../../../app/scope";
import { useAuth } from "../../../auth/auth-context";

// Legacy object links (ADR-080): the new home of a legacy id comes from the cutover map; until the map is loaded
// the page offers search and the list the object belongs to.
const LISTS: Record<string, string> = {
  run: "runs",
  sandbox: "sandboxes",
  workspace: "workspaces",
  instance: "workspaces",
  agent: "agents",
  group: "agents?tab=groups",
};

export const Route = createFileRoute("/_authed/moved")({
  validateSearch: (s: Record<string, unknown>): { legacy?: string } => (typeof s.legacy === "string" ? { legacy: s.legacy } : {}),
  component: Moved,
});

function Moved() {
  const { legacy = "" } = Route.useSearch();
  const { session } = useAuth();
  const navigate = useNavigate();
  const [type, id] = legacy.split(":", 2) as [string, string | undefined];
  const last = lastScope(session?.user.id ?? "");
  const org = last.org;
  const list = org ? `/${encodeURIComponent(org)}/${encodeURIComponent(last.project(org))}/${LISTS[type] ?? "overview"}` : "/";
  const [q, setQ] = React.useState(id ?? "");
  return (
    <AuthCard title="This link is from the previous console" description={id ? <>We could not find a new home for <code className="font-mono">{id}</code> yet.</> : undefined}>
      <form
        className="grid gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          void navigate({ href: `${list}${list.includes("?") ? "&" : "?"}q=${encodeURIComponent(q)}` });
        }}
      >
        <Input aria-label="Search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name" />
        <Button type="submit">Search</Button>
      </form>
      <div className="mt-4">
        <ActionLink href={list}>Open the list</ActionLink>
      </div>
    </AuthCard>
  );
}
